import { queryOptions } from '@tanstack/react-query';

import { PracticeApi } from '@api/PracticeApi';

export const practiceKeys = {
    all: ['practices'] as const,
    contacts: () => [...practiceKeys.all, 'contacts'] as const,
};

export const practiceQueryOptions = {
    contacts: () =>
        queryOptions({
            staleTime: Infinity,
            queryKey: practiceKeys.contacts(),
            queryFn: () => PracticeApi.getPracticeData(),
        }),
};
